// START: Random Rating
const ratings = ["4.6/5.0", "4.7/5.0", "4.8/5.0", "4.9/5.0", "5.0/5.0"];
const randomRating = ratings[Math.floor(Math.random() * ratings.length)];
var elRating = document.getElementById("rating");
if (elRating) { elRating.innerText = randomRating; }
// END: Random Rating

// START: Free Offer Modal
(function() {
  const root = document.querySelector('.js-free-offer');
  if (!root) return;

  const openBtn = root.querySelector('.js-free-offer-btn');
  const modal   = root.querySelector('.js-free-offer-modal');
  const dialog  = modal?.querySelector('.free-offer__dialog');

  const backBtn = modal.querySelector('[data-back]');
  const nextBtn = modal.querySelector('[data-next]');
  const doneBtn = modal.querySelector('[data-done]');
  const dots    = modal.querySelectorAll('[data-step-dot]');
  const steps   = modal.querySelectorAll('.step');

  let lastFocused, current = 1, total = 3;

  function openModal() {
    lastFocused = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    showStep(1);

    const focusables = dialog.querySelectorAll(
      'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    (focusables[0] || dialog).focus();

    document.addEventListener('keydown', onKeydown);
    modal.addEventListener('click', onModalClick, true);
    wireClosers();
  }

  function wireClosers() {
    const closers = modal.querySelectorAll('[data-close]');
    closers.forEach(el => {
      el.addEventListener('click', onCloserClick, { passive: false });
    });
  }
  function unwireClosers() {
    const closers = modal.querySelectorAll('[data-close]');
    closers.forEach(el => {
      el.removeEventListener('click', onCloserClick);
    });
  }
  function onCloserClick(e) {
    e.preventDefault();
    e.stopPropagation();
    closeModal();
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    modal.removeEventListener('click', onModalClick, true);
    unwireClosers();
    if (lastFocused) lastFocused.focus();
  }

  function onModalClick(e) {
    const isBackdrop = e.target.matches('[data-close]') || e.target.closest('[data-close]');
    if (isBackdrop) return closeModal();
    if (dialog.contains(e.target)) return;
    return closeModal();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') return closeModal();
    if (e.key === 'ArrowRight') goNext();
    if (e.key === 'ArrowLeft') goBack();
    if (e.key === 'Tab') handleTab(e);
    if (e.key === 'Enter' && !nextBtn?.hidden) goNext();
  }

  function handleTab(e) {
    const focusable = dialog.querySelectorAll(
      'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }

  function showStep(n) {
    current = Math.min(Math.max(n,1), total);
    steps.forEach(s => {
      const stepNum = Number(s.getAttribute('data-step'));
      s.hidden = stepNum !== current;
      if (!s.hidden) { s.setAttribute('tabindex','-1'); s.focus?.(); }
      else { s.removeAttribute('tabindex'); }
    });
    dots.forEach(d => {
      const dn = Number(d.getAttribute('data-step-dot'));
      d.classList.toggle('is-active', dn === current);
    });
    if (backBtn) backBtn.disabled = current === 1;
    if (nextBtn && doneBtn) {
      if (current === total) { nextBtn.hidden = true; doneBtn.hidden = false; }
      else { nextBtn.hidden = false; doneBtn.hidden = true; }
    }
  }

  function goNext(){ if (current < total) showStep(current + 1); }
  function goBack(){ if (current > 1) showStep(current - 1); }

  root.freeOfferOpen = function(e){ e && e.preventDefault(); openModal(); };
  backBtn?.addEventListener('click', goBack);
  nextBtn?.addEventListener('click', goNext);

  const doneBehavior = root?.getAttribute('data-done-behavior') || 'follow';
  const doneLink = root?.getAttribute('data-done-link') || null;
  doneBtn?.addEventListener('click', function(e){
    if (doneBehavior === 'close') {
      e.preventDefault();
      closeModal();
    } else if (doneBehavior === 'close_and_go') {
      e.preventDefault();
      closeModal();
      if (doneLink) setTimeout(function(){ window.location.href = doneLink; }, 50);
    } else {
      
    }
  });
})();
// END: Free Offer Modal

// START: Product Reviews Slider Init
function initProductReviews() {
  setTimeout(() => {
    const slider = new Swiper('.testimonials-slider__track.swiper', {
      speed: 200,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.testimonial-nav--next',
        prevEl: '.testimonial-nav--prev'
      },
    });
  }, 200);
}
document.addEventListener('DOMContentLoaded', initProductReviews);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:unload', initProductReviews);
  document.addEventListener('shopify:section:load', initProductReviews);
}
// END: Product Reviews Slider Init

// START: Inventory Random Stock
const randomStock = Math.floor(Math.random() * (3 - 6 + 1)) + 5;
const stockMsgEl = document.getElementById("stock-message");
if (stockMsgEl) stockMsgEl.innerText = ` ${randomStock} `;
// END: Inventory Random Stock

// START: Free Shipping Message
document.addEventListener('DOMContentLoaded', function () {
  const price = parseFloat(document.getElementById('product-price')?.dataset.price || '0');
  const qtyInput = document.querySelector('input[name="quantity"]');
  const msgBox = document.getElementById('free-shipping-msg');
  const threshold = 499;

  function updateMsg() {
    const qty = parseInt(qtyInput?.value) || 1;
    const total = price * qty;
    if (!msgBox) return;
    if (total >= threshold) {
      msgBox.innerHTML = '<span style=" font-size: 15px;background-color: #51422d0d;padding: 8px 12px;border-radius: 6px;display: inline-block;margin-top: -15px !important;margin-bottom: 0;color: #000;font-weight: 600;font-size: 13px;">🚚 Free Shipping Available</span>';
    } else {
      msgBox.innerHTML = '';
    }
  }

  if (qtyInput) {
    qtyInput.addEventListener('input', updateMsg);
    qtyInput.addEventListener('change', updateMsg);
    updateMsg();
  }
});
// END: Free Shipping Message

// START: Sticky Add To Cart & Variant Sync
function getVariantIdFun(th){
  const variant_title = th.options[th.selectedIndex].text;
  const variant_options_arr = variant_title.split(' / ');
  for(let vkey = 0; vkey < variant_options_arr.length; vkey++){
    const voption_name = variant_options_arr[vkey];
    const label = document.querySelector(`label[data-variant-name='${voption_name}']`);
    label && label.click();
  }
}
document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('sticky-add-to-cart');
  const mainAddToCart = document.querySelector('form[action^="/cart/add"] .product-form__buttons');
  const stickyButton = document.getElementById('sticky-cart-btn');
  if (!stickyBar || !mainAddToCart || !stickyButton) return;
  let ticking = false;
  function updateSticky() {
    const rect = mainAddToCart.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
    stickyBar.style.display = isVisible ? 'none' : 'block';
    ticking = false;
  }
  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateSticky);
  }
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  requestUpdate();
});
// END: Sticky Add To Cart & Variant Sync

// START: Size Chart Modal
let size_btn = document.getElementById("SizeChartBtn");
let size_content = document.getElementById("ProductSizeChart");
let size_close =  document.getElementById("size-modal-close");
function sizeChartClick() { size_content && size_content.classList.add("is-active"); }
if (size_close) { size_close.onclick = function() { size_content && size_content.classList.remove("is-active"); }; }
window.onclick = function(event) { if (event.target == size_content) { size_content && size_content.classList.remove("is-active"); } };
// END: Size Chart Modal

// START: Auto Play Deferred Media
window.addEventListener('load', function () {
  setTimeout(function () {
    const mediaPoster = document.querySelector('.deferred-media__poster');
    if (mediaPoster) { mediaPoster.click(); }
  }, 500);
});
// END: Auto Play Deferred Media

// START: s-proff.liquid <script> block 1 (moved as-is)
(function () {
  // Simple deterministic PRNG seeded by a number
  function mulberry32(a) {
    return function() {
      var t = (a += 0x6D2B79F5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function shuffleDeterministic(arr, rand) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function uniquePair(arr, rand) {
    if (!arr || arr.length < 2) return [null, null];
    const i = Math.floor(rand() * arr.length);
    let j = Math.floor(rand() * (arr.length - 1));
    if (j >= i) j += 1;
    return [arr[i], arr[j]];
  }

  function clamp(n, min, max) { return Math.min(max, Math.max(min, n)); }

  function buildCheckSVG(fill) {
    return '<span><svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11.36 5.17499L10.44 4.43499c-.0738-.05888-.131-.13592-.166-.22357-.0351-.08765-.0468-.1829-.034-.27643l.125-1.17c.0174-.15546-.0004-.31284-.052-.46052-.0515-.14769-.1356-.28191-.246-.39276-.11037-.11085-.24422-.19551-.39168-.24773-.14746-.05222-.30476-.07067-.4603-.05399l-1.175.125c-.09353.01282-.18878.00113-.27643-.03393-.08765-.03606-.16469-.09328-.22357-.16707L6.815.629993A1.019 1.019 0 0 0 6 .258636c-.1545 0-.30721.033151-.44781.097215-.1406.064064-.26581.157548-.36719.274142L4.445 1.54999c-.05888.07379-.136.13101-.22365.16607-.08765.03506-.1829.04675-.27643.03393l-1.16-.125c-.15554-.01668-.31284.00177-.4603.05399-.14746.05222-.28121.13688-.39158.24773-.11037.11085-.19445.24507-.24603.39275-.05158.14769-.06935.30507-.052.46053l.125 1.17c.01282.09353.00113.18878-.03393.27643-.03506.08765-.09228.16469-.16607.22357l-.92.725c-.122013.09792-.220484.22199-.288146.36305C.284211 5.6791.249084 5.83355.249084 5.98999c0 .15645.035127.3109.10279.45196.067663.14106.166134.26512.288146.36304l.92.74c.07341.05921.13036.13629.16538.22385.03502.08756.04695.18266.03462.27615l-.125 1.175c-.01733.15514.00065.31218.0526.45938.05195.1471.13652.28064.24739.38954.10831.11298.24165.19908.38928.25118.14764.0521.30545.0688.46073.0498l1.175-.125c.09353-.0128.18878-.0011.27643.0339.08765.0351.16469.0923.22357.1661l.74.92c.09792.122.222.22.36305.288.14105.068.2955.103.45195.103.15645 0 .3109-.035.45196-.103.14105-.068.26512-.166.36304-.288l.74-.92c.05888-.0738.13592-.131.22357-.166.08765-.0351.1829-.0469.27643-.034l1.175.125c.15528.02.31308.003.46072-.049.14763-.0521.28097-.1382.38926-.2512.1109-.109.1955-.2425.2475-.3897.052-.1472.07-.3042.0526-.4593l-.125-1.175c-.0123-.0935-.0004-.1886.0346-.2762.035-.0876.092-.1647.1654-.2239l.92-.74c.122-.0979.22-.222.2877-.363.0676-.1411.1028-.2955.1028-.4519 0-.15644-.0352-.31089-.1028-.45195-.0677-.14106-.1662-.26513-.2882-.36305l-.93-.63c.152-.148-.0709-.525-.22-.62Zm-5.16 2.35c-.07705.10027-.17447.18308-.28584.24296-.11138.05989-.23418.09549-.36032.10447-.12613.00897-.25274-.00808-.37147-.05159-.11873-.04351-.2269-.11176-.31737-.20011L3.645 6.39999c-.04662-.04662-.0836-.10196-.10883-.16287-.02523-.06091-.0382-.12711-.0382-.22115 0-.06593.01299-.13121.03822-.19212.02523-.06091.06221-.11625.10883-.16287.04662-.04662.10196-.0836.16287-.10883.06091-.02523.12619-.03821.19212-.03821.06593 0 .13121.01298.19213.03821.06091.02523.11625.06221.16287.10883l1.145 1.125 1.955-2.605c.07956-.10608.19801-.17622.32929-.19497.065.00929.13118.0129.19479.0292.06361.01629.12338.04496.17591.08435.05253.03939.09678.08875.13024.14525.03345.0565.05545.11928.06473.18428.00929.06499.00568.13119-.01062.19479-.0163.06361-.04496.12338-.08436.17591L6.2 7.52499z" fill="' + fill + '"></path></svg></span>';
  }

  function insertSection() {
    const template = document.querySelector('.js-ss-social-proof-template');
    if (!template) return;
    const anchorSel = template.dataset.anchor || '#ss-social-proof';
    const placement = template.dataset.placement || 'afterend';
    let host = document.querySelector('#ss-social-proof') || document.querySelector(anchorSel);
    if (!host) return;
    const content = template.content.firstElementChild.cloneNode(true);
    host.insertAdjacentElement(placement, content);
    return content;
  }

  function hydrate(contentRoot) {
    const dataEl = document.querySelector('.js-ss-proof-data');
    if (!dataEl) return;
    let cfg = {};
    try { cfg = JSON.parse(dataEl.textContent || '{}'); } catch(e) {}

    // Seed by productId so each product stays consistent across loads
    const seed = Number(cfg.productId || 0) || 0;
    const rand = mulberry32(seed || 1);

    // 1) Randomize thumbnails from product images (if enabled)
    if (cfg.useProductImages && Array.isArray(cfg.images) && cfg.images.length) {
      const chosen = shuffleDeterministic(cfg.images, rand).slice(0, 3);
      const thumbs = contentRoot.querySelectorAll('.ss-proof-image img');
      const templateEl = document.querySelector('.js-ss-social-proof-template');
      const sizeMobile = parseInt((templateEl && templateEl.dataset && templateEl.dataset.imageSizeMobile) || '0') || 0;
      for (let i = 0; i < thumbs.length; i++) {
        const img = thumbs[i];
        const src = chosen[i % chosen.length];
        if (!img || !src) continue;
        img.src = src;
        img.decoding = 'async';
        img.loading = img.getAttribute('loading') || 'lazy';
        img.alt = 'Customer photo';
        if (sizeMobile) { img.width = sizeMobile; img.height = sizeMobile; }
      }
    }

    // 2) Choose two names deterministically per product
    const pool = (cfg.names || []).map(n => String(n).trim()).filter(Boolean);
    const fallback = ['Alex','Sam','Taylor','Jordan'];
    const [name1, name2] = uniquePair(pool.length ? pool : fallback, rand);

    // 3) Random "others" number (deterministic per product)
    const min = Number(cfg.othersMin || 1500);
    const max = Number(cfg.othersMax || 1500);
    const others = Math.floor(clamp(min + rand() * (max - min + 1), min, max));

    // 4) Inject text with inline tick icon color
    const textWrap = contentRoot.querySelector('.ss-proof-text');
    if (textWrap && name1 && name2) {
      const tick = buildCheckSVG(cfg.iconColor || '#42A5F5');
      textWrap.innerHTML =
        '<p><strong>' + name1 + '</strong> ' + tick + ', <strong>' + name2 +
        '</strong> ' + tick + ' and <strong>' + others +
        '+</strong> others love our products!</p>';
    }
  }

  window.addEventListener('DOMContentLoaded', function () {
    const inserted = insertSection();
    if (inserted) hydrate(inserted);
  });
})();
// END: s-proff.liquid <script> block 1

// START: s-proff.liquid <script> block 2 (moved as-is)
document.addEventListener('DOMContentLoaded', () => {
  const template = document.querySelector('.js-ss-social-proof-template');
  const host = document.querySelector('.product__title') || document.querySelector('.product__info-container');
  if (!template || !host) return;

  const clone = template.content.firstElementChild.cloneNode(true);
  host.insertAdjacentElement('afterend', clone);

  const dataEl = document.querySelector('.js-ss-proof-data');
  if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent || '{}');

  const rand = (seed) => {
    const x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  };

  // Randomize images
  if (data.useProductImages && Array.isArray(data.images) && data.images.length) {
    const shuffled = data.images.sort(() => 0.5 - Math.random()).slice(0, 3);
    const thumbs = clone.querySelectorAll('.proof-thumb');
    thumbs.forEach((img, i) => {
      img.src = shuffled[i % shuffled.length];
    });
  }

  // Random names
  const names = data.names || [];
  const name1 = names[Math.floor(rand(data.productId) * names.length)] || 'Tanisha';
  const name2 = names[Math.floor(rand(data.productId + 1) * names.length)] || 'Rahin';
  const others = 1500 ;

  const tick = `<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11.36 5.17499L10.44 4.43499c-.0738-.05888-.131-.13592-.166-.22357-.0351-.08765-.0468-.1829-.034-.27643l.125-1.17c.0174-.15546-.0004-.31284-.052-.46052-.51-.14769-.1356-.28191-.246-.39276-.11037-.11085-.24422-.19551-.39168-.24773-.14746-.05222-.30476-.07067-.4603-.05399l-1.175.125c-.09353.01282-.18878.00113-.27643-.03393-.08765-.03606-.16469-.09328-.22357-.16707L6.815.629993A1.019 1.019 0 0 0 6 .258636c-.1545 0-.30721.033151-.44781.097215-.1406.064064-.26581.157548-.36719.274142L4.445 1.54999c-.05888.07379-.136.13101-.22365.16607-.08765.03506-.1829.04675-.27643.03393l-1.16-.125c-.15554-.01668-.31284.00177-.4603.05399-.14746.05222-.28121.13688-.39158.24773-.11037.11085-.19445.24507-.24603.39275-.05158.14769-.06935.30507-.052.46053l.125 1.17c.01282.09353.00113.18878-.33.27643-.03506.08765-.09228.16469-.16607.22357l-.92.725c-.122013.09792-.220484.22199-.288146.36305C.284211 5.6791.249084 5.83355.249084 5.98999c0 .15645.035127.3109.10279.45196.067663.14106.166134.26512.288146.36304l.92.74c.07341.05921.13036.13629.16538.22385.03502.08756.04695.18266.03462.27615l-.125 1.175c-.01733.15514.00065.31218.0526.45938.05195.1471.13652.28064.24739.38954.10831.11298.24165.19908.38928.25118.14764.0521.30545.0688.46073.0498l1.175-.125c.09353-.0128.18878-.0011.27643.0339.08765.0351.16469.0923.22357.1661l.74.92c.09792.122.222.22.36305.288.14105.068.2955.103.45195.103.15645 0 .3109-.035.45196-.103.14105-.068.26512-.166.36304-.288l.74-.92c.05888-.0738.13592-.131.22357-.166.08765-.0351.1829-.0469.27643-.034l1.175.125c.15528.02.31308.003.46072-.049.14763-.0521.28097-.1382.38926-.2512.1109-.109.1955-.2425.2475-.3897.052-.1472.07-.3042.0526-.4593l-.125-1.175c-.0123-.0935-.0004-.1886.0346-.2762.035-.0876.092-.1647.1654-.2239l.92-.74c.122-.0979.22-.222.2877-.363.0676-.1411.1028-.2955.1028-.4519 0-.15644-.0352-.31089-.1028-.45195-.0677-.14106-.1662-.26513-.2882-.36305l-.93-.63z"/>`;

  const text = `<p><strong>${name1}</strong> ${tick}, <strong>${name2}</strong> ${tick} and <strong>1500+</strong> others love our products!</p>`;

  const textWrap = clone.querySelector('.ss-proof-text');
  if (textWrap) textWrap.innerHTML = text;
});
// END: s-proff.liquid <script> block 2


// START: Delivery Timeline
document.addEventListener('DOMContentLoaded', function () {
  function formatDate(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  const today = new Date();
  const orderDate = new Date(today);

  const shipEstimateStart = new Date(orderDate);
  shipEstimateStart.setDate(orderDate.getDate() + 2);

  const shipEstimateEnd = new Date(orderDate);
  shipEstimateEnd.setDate(orderDate.getDate() + 4);

  const deliveryEstimateStart = new Date(shipEstimateStart);
  deliveryEstimateStart.setDate(shipEstimateStart.getDate() + 4);

  const deliveryEstimateEnd = new Date(shipEstimateStart);
  deliveryEstimateEnd.setDate(shipEstimateStart.getDate() + 6);

  var elOrder = document.getElementById("order-date");
  
  if (elOrder) {
    elOrder.innerText = formatDate(orderDate);
  }

  var elShip = document.getElementById("ship-date");
  if (elShip) {
    elShip.innerText = `${formatDate(shipEstimateStart)} → ${formatDate(shipEstimateEnd)}`;
  }

  var elDelivery = document.getElementById("delivery-date");
  if (elDelivery) {
    elDelivery.innerText = `${formatDate(deliveryEstimateStart)} → ${formatDate(deliveryEstimateEnd)}`;
  }
});
// END: Delivery Timeline
